var _filter, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    enableBackground: "new 0 0 29 29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    width: 29,
    height: 29,
    id: "Ellipse_138",
    filterUnits: "userSpaceOnUse",
    y: 0,
    x: 0
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha",
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    transform: "translate(4.5 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Ellipse_138)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138-2_1_",
    fill: "#E10092",
    cx: 14.5,
    cy: 13.5,
    r: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-right",
    fill: "#FFFFFF",
    d: "M6.919,9.909l4.2-4.2c0.202-0.203,0.531-0.203,0.734,0l0,0l0.489,0.49 c0.202,0.202,0.202,0.53,0,0.732l-3.325,3.344l3.331,3.347c0.202,0.202,0.202,0.53,0,0.732l-0.49,0.49 c-0.202,0.203-0.531,0.203-0.733,0l0,0l-4.206-4.199c-0.204-0.202-0.206-0.53-0.004-0.734C6.916,9.912,6.918,9.91,6.919,9.909z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.b8576834ee8d3fa544c98e39cd122390.svg";
export { ForwardRef as ReactComponent };